import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GlobalValidators } from '../../utils/validators';
import { PortalProductsService } from '../../services/portal-products.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-otpscreen',
  templateUrl: './otpscreen.component.html',
  styleUrls: ['./set-pin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtpscreenComponent implements OnInit, OnChanges {
  @Input() currentUser;
  @Input() newPin;
  @Output() sentOTPSuccess = new EventEmitter();
  enterOTPFG: FormGroup;
  otpErrorMassage: any;
  resendingVerificationCodes: boolean;
  otpVerifying: boolean;
  otpSendResponse = null;
  @ViewChild('otpPin1Row') otpPin1Row: any;
  @ViewChild('otpPin2Row') otpPin2Row: any;
  @ViewChild('otpPin3Row') otpPin3Row: any;
  @ViewChild('otpPin4Row') otpPin4Row: any;

  constructor(private fb: FormBuilder, private cdref: ChangeDetectorRef, private portalProductService: PortalProductsService, public translate: TranslateService) { }

  // Helper method to get element by index
  private getElementByIndex(index: number): any {
    const elements = [this.otpPin1Row, this.otpPin2Row, this.otpPin3Row, this.otpPin4Row];
    return elements[index];
  }

  async ngOnInit() {
    await this.bindOtp();
    const firstElement = this.getElementByIndex(0);
    if (firstElement?.nativeElement) {
      firstElement.nativeElement.focus();
    }
  }
  async ngOnChanges(changes: SimpleChanges) {
    if (changes['currentUser'] && this.currentUser) {
      await this.sendOtp();
    }
  }
  async bindOtp() {
    this.enterOTPFG = this.fb.group({
      otp: new FormGroup({
        pin1: new FormControl('', GlobalValidators.required),
        pin2: new FormControl('', [GlobalValidators.required]),
        pin3: new FormControl('', [GlobalValidators.required]),
        pin4: new FormControl('', [GlobalValidators.required]),
      }),
    });
    this.enterOTPFG.valueChanges.subscribe((val) => {
      this.otpErrorMassage = '';
    });
  }

  getCode = (value) => {
    let pinCode = '';
    ['pin1', 'pin2', 'pin3', 'pin4'].map((field) => {
      pinCode = pinCode + (value[field] ? value[field]?.toString() : '');
    });
    return pinCode;
  };

  async navigateToNext(e, nextTab?, backTab?) {
    console.log(e.key, e.keyCode);
    if (e.keyCode === 16 || e.keyCode === 46 || e.keyCode === 9 || e.keyCode === 8) return '';
    if ((e.keyCode === 37 || e.keyCode === 8) && backTab) $('[tabindex=' + backTab + ']').focus();
    if (nextTab) $('[tabindex=' + nextTab + ']').focus();
  }

  restrictInput(event: KeyboardEvent, index): void {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight'];
    // Allow navigation and editing keys
    if (allowedKeys.includes(event.key)) {
      let pos = index;
      if (event.keyCode === 8 || event.keyCode === 37) {
        const currentElement = this.getElementByIndex(index);
        if (event.keyCode === 8 && currentElement?.nativeElement?.value) {
          pos = index;
        } else {
          pos = index - 1;
        }
      } else {
        pos = index + 1;
      }
      if (pos > -1 && pos < 4) {
        const targetElement = this.getElementByIndex(pos);
        if (targetElement?.nativeElement) {
          const valueLength = targetElement.nativeElement.value.length;
          targetElement.nativeElement.setSelectionRange(valueLength, valueLength);
          targetElement.nativeElement.focus();
        }
      }
      return;
    }

    // Allow numeric input (0-9)
    if (/^[0-9]$/.test(event.key)) {
      return;
    }

    // Prevent any other key
    event.preventDefault();
  }

  async validateInput(event, index, formControl) {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');

    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (this.enterOTPFG.get('otp').get(formControl).value) {
      let pos = index;
      if (event.keyCode === 8 || event.keyCode === 37) {
        pos = index - 1;
      } else {
        pos = index + 1;
      }
      if (pos > -1 && pos < 4) {
        const targetElement = this.getElementByIndex(pos);
        if (targetElement?.nativeElement) {
          targetElement.nativeElement.focus();
        }
      }
      if (this.enterOTPFG.valid && index === 3) {
        await this.validateOTP(this.enterOTPFG);
      }
    }
  }

  validateOTP = async (form) => {
    // console.log(form);
    if (form.invalid) {
      return;
    }
    let enteredOTP = form.value['otp'] ? this.getCode(form.value['otp']) : '';

    try {
      this.otpVerifying = true;
      await this.portalProductService.validateOtp(enteredOTP);

      this.otpVerifying = false;
      this.sentOTPSuccess.emit(this.newPin ? 'save' : 'update');
      // this.savePin();
      this.cdref.detectChanges();
    } catch (e) {
      this.otpVerifying = false;
      this.otpErrorMassage = e.error.message;
      this.cdref.detectChanges();
    }
  };

  sendOtp = async () => {
    this.otpErrorMassage = null;
    let userDTO = {
      mobilePhoneCountryCode: this.currentUser.mobilePhoneCountryCode || '',
      mobilePhoneAreaCode: this.currentUser.mobilePhoneAreaCode || '',
      mobilePhoneNumber: this.currentUser.mobilePhoneNumber || '',
    };
    try {
      this.resendingVerificationCodes = true;
      this.otpSendResponse = await this.portalProductService.sendOTP();
      this.resendingVerificationCodes = false;
    } catch (e) {
      this.resendingVerificationCodes = false;
      console.log(e);
      this.otpErrorMassage = e?.error?.message;
    }
    this.cdref.detectChanges();
  };
}
